export type DeleteIfConversionRulesRequest = {
  envCopyIfDfnCnvRule: {
    idx: number;
    ifDfnCnvRuleId: string;
    updateDateTime: string;
  }[];
};
